import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6de97d2c"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6de97d2c')) {
      api.createRecord('6de97d2c', component.options)
    } else {
      api.reload('6de97d2c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6de97d2c", function () {
      api.rerender('6de97d2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/cost_pool_scale/index.vue"
export default component.exports